export enum DropoffStatus {
  AWAITING_DROPOFF = "awaiting_dropoff",
  DROPPED_OFF = "dropped_off",
  IN_TRANSIT = "in_transit",
  DELIVERED = "delivered",
}

export const dropoffStatusToDisplayText: Record<DropoffStatus, string> = {
  [DropoffStatus.AWAITING_DROPOFF]: "Awaiting drop-off",
  [DropoffStatus.DROPPED_OFF]: "Dropped off",
  [DropoffStatus.IN_TRANSIT]: "In transit",
  [DropoffStatus.DELIVERED]: "Delivered",
};
